const dateTime = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' });
const date = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' });

export const formatDateTime = (value?: string) => value ? dateTime.format(new Date(value)) : '';
export const formatDate = (value?: string) => value ? date.format(new Date(value)) : '';

// Same rules as the API (SharedUtils.IsValidEmailAddress / IsPlusAddressed), so the form catches what it would refuse.
export function emailProblem(email: string): string | undefined {
    const value = email.trim();
    if (!/^[^\s@<>()[\]\\.,;:"]+(\.[^\s@<>()[\]\\.,;:"]+)*@([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}$/.test(value)) {
        return 'Enter a valid email address.';
    }
    if (value.split('@')[0].includes('+')) {
        return "Addresses with '+' aren't supported.";
    }
    return undefined;
}

export const MIN_PASSWORD_LENGTH = 10;

export function newPasswordProblem(password: string, confirm: string): string | undefined {
    if (password.length < MIN_PASSWORD_LENGTH) {
        return `Use at least ${MIN_PASSWORD_LENGTH} characters.`;
    }
    if (password !== confirm) {
        return "The passwords don't match.";
    }
    return undefined;
}
